<ng-container *ngIf="config?.skipAclCheck || (menuGuards && (menuGuards[config?.id] | async))">
  <div (click)="navigate(config?.route)" class="sub-menu-item-wrapper">
    <span [id]="selectedPrimaryNavConfigId + '-' + selectedSecondaryNavConfigId + '-' + config?.id"
      [ngClass]="{ active: (activeTertiaryNavMenuId$ | async) === config?.id }" class="sub-menu-item">
      {{ config?.label }}
    </span>
  </div>
</ng-container>
